import { createAction, props } from '@ngrx/store';

// Группировка всех действий
export const PermissionsActions = {
    // Успешная загрузка
    loadPermissionsSuccess: createAction('[Permissions] Load Permissions Success', props<{ permissions: { targets: string[] } }>()),

    // Ошибка загрузки
    loadPermissionsFailure: createAction('[Permissions] Load Permissions Failure', props<{ error: unknown }>()),

    // Обновление ролей
    updatePermissions: createAction('[Permissions] Update Permissions', props<{ permissions: { targets: string[] } }>()),

    // Запуск навигации когда permissions загружены
    triggerNavigationOnLoaded: createAction('[Permissions] Trigger Navigation On Loaded', props<{ redirectUrl: string | null }>()),

    // Завершение анимации лоадера и запуск навигации
    loaderAnimationCompleted: createAction('[Permissions] Loader Animation Completed', props<{ redirectUrl: string | null }>())
} as const;